import { type ReactNode } from 'react'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogCompactHeader,
  ModalDialogFooter,
} from '@/components/ModalDialog'

import { Button } from '@/components/Button'
import { ModalDialogWizardNavContent } from '@/components/Wizard/WizardNav'

export interface DraftJobNavigationModalProps {
  /**
   * The wizard navigation content to render.
   */
  children?: ReactNode
  /**
   * Whether the modal is open.
   */
  isOpen: boolean
  /**
   * Callback when the modal should close.
   */
  onClose?: () => unknown
  /**
   * Test ID attribute.
   */
  testId?: string
  /**
   * Test ID attribute for the close button.
   */
  closeTestId?: string
}

/**
 * Info gathering navigation modal.
 * The wizard nav list should be using the `flat` variant.
 */
export function DraftJobNavigationModal({
  children,
  isOpen,
  onClose,
  testId,
  closeTestId,
}: DraftJobNavigationModalProps) {
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      sheetSizing="stretch"
      testId={testId}
    >
      <ModalDialogCompactHeader>Question overview</ModalDialogCompactHeader>
      <ModalDialogWizardNavContent spacingY="gapless-pull-up" spacingX="flat">
        {children}
      </ModalDialogWizardNavContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            variant="outline"
            label="Close"
            onPress={onClose}
            testId={closeTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
